<!-- 360落地页管理-新增 -->
<template>
<div style="">
	<!-- 标题 -->
	<div class="page-title" style="margin-left: 30px;">{{page_title}}360落地页</div>
	
	<div style="width: 70vw;margin: 30px auto 30px;">
		
		
		<div class="form-cell-box">
			<div class="class-title">名称<span class="required-hint">*</span></div>
				
			<a-input v-model="r_title" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">渠道<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_channel_id"
			  >
				<a-select-option v-for="(item,index) in channel_idList" :key="index" :value="item.key">
				  {{item.value}}
				</a-select-option>
			</a-select>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">公众号<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				notFoundContent="请先选择: 渠道 ↑" 
				@change="addChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_gzh_id"
			  >
				<a-select-option v-for="(value,key) in gzhSelectList" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		
		
		<!-- 360落地页开始 -->
		<div class="form-cell-box">
			<div class="class-title">公众号二维码<span class="required-hint">*</span></div>
			<div v-show="!gzh_360_code_url">当前公众号没有永久二维码</div>
			<img v-show="gzh_360_code_url" :src="gzh_360_code_url" style="width: 100px;height: 100px;">
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">媒体版位<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeD"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_media_id"
			  >
				<a-select-option v-for="(value,key) in mediaSelectList" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		
		
		<!-- 页面元素设置................. -->
		<div class="form-cell-box">
			<div class="class-title" style="font-size: 18px;font-weight: bold;">页面元素设置</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">页面样式模板<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeE"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				notFoundContent="请先选择: 媒体版位 ↑" 
				:value="r_template_id"
			  >
				<a-select-option v-for="(value,key) in sixMubanList" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">域名地址<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeF"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_put_url"
			  >
				<a-select-option v-for="(value,key) in domainList" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		
		<!-- 顶部图片 -->
		<div class="form-cell-box">
			<div class="class-title">顶部图片</div>
			<div style="display: flex;align-items: center;">
				<a-upload
					accept="image/*"
				    name="file"
				    list-type="picture-card"
				    class="avatar-uploader"
				    :show-upload-list="false"
				    :action="`${$http.excel_url}api/common/upload-image`"
					:data="{
						'name': 'Image.png',
						'type': 1
					}"
					:headers="{
						'Authorization': headers_token
					}"
					:withCredentials="true"
					method="post" 
				    :before-upload="beforeUpload"
				    @change="uploadChange"
				  >
				  <img v-if="imageUrl" :src="imageUrl" style="width: 500px;height: 240px;object-fit: contain;" alt="avatar" />
				    <div v-else style="width: 500px;height: 240px;display: flex;align-items: center;flex-direction: column;justify-content: center;">
				      <a-icon :type="loading ? 'loading' : 'plus'" style="font-size: 26px;" />
				      <div class="" style="margin-top: 15px;">
				        选择图片
				      </div>
				    </div>
				</a-upload>
				<a-button @click="delTopImg" v-if="imageUrl" style="margin-left: 30px;" size="small" type="danger">删除</a-button>
			</div>
		</div>
		
		<div class="form-cell-box" style="margin-bottom: 30px;">
			<div class="class-title" style="flex-shrink: 0;">投放内容</div>
			<Editors :html_value="r_put_content" @change_editor="changeEditorT"></Editors>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">背景色</div>
				
			<a-radio-group name="radioGroup"  @change="changeColor"  :value="r_background_color" style="display: flex;">
			    <a-radio value="#FFFFFF" style="display: flex;align-items: center;">
					<div style="background-color:#FFFFFF;">纯白</div>
			    </a-radio>
			    <a-radio value="#F6F2C4" style="display: flex;align-items: center;">
					<div style="background-color:#F6F2C4;">黄色</div>
			    </a-radio>
			    <a-radio value="#CBE5FC" style="display: flex;align-items: center;">
					<div style="background-color:#CBE5FC;">天空蓝</div>
			    </a-radio>
			    <a-radio value="#F1D6DF" style="display: flex;align-items: center;">
					<div style="background-color:#F1D6DF;">樱花粉</div>
			    </a-radio>
			</a-radio-group>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">审核公司<span class="required-hint">*</span></div>
				
			<a-input v-model="r_company_name" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">网址名称<span class="required-hint">*</span></div>
				
			<a-input v-model="r_logo" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">联系电话<span class="required-hint">*</span></div>
				
			<a-input v-model="r_phone" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">公司地址<span class="required-hint">*</span></div>
				
			<a-input v-model="r_address" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">投放开关</div>
				
			<a-switch @change="addChangeTC" :checked="r_open_put" checked-children="打开" un-checked-children="关闭" />
		</div>
		
		<!-- 跳转设置................. -->
		<div class="form-cell-box">
			<div class="class-title" style="font-size: 18px;font-weight: bold;">跳转设置</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">跳转方式<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeC"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_jump_type"
			  >
				<a-select-option  value="scan">
				  扫码关注（仅360）
				</a-select-option>
			</a-select>
		</div>
		
		
		<!-- 回传设置................. -->
		<div class="form-cell-box">
			<div class="class-title" style="font-size: 18px;font-weight: bold;">回传设置</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">回传方式<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeG360"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_report_method"
			  >
				<a-select-option  value="1">
				  页面底部JS回传
				</a-select-option>
				<a-select-option  value="2">
				  关注API回传
				</a-select-option>
			</a-select>
		</div>
		
		<div v-show="r_report_method == '1'" class="form-cell-box">
			<div class="class-title">360分析站点ID<span class="required-hint">*</span></div>
				
			<a-input v-model="r_foreign_id" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div v-show="r_report_method == '1'" class="form-cell-box">
			<div class="class-title">360分析自定义转换ID<span class="required-hint">*</span></div>
				
			<a-input v-model="r_foreign_code" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div v-show="r_report_method == '2'" class="form-cell-box">
			<div class="class-title">API_JZQS<span class="required-hint">*</span></div>
				
			<a-input v-model="r_foreign_id" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div v-show="r_report_method == '2'" class="form-cell-box">
			<div class="class-title">API_KEY<span class="required-hint">*</span></div>
				
			<a-input v-model="r_api_key" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div v-show="r_report_method == '2'" class="form-cell-box">
			<div class="class-title">API_SECRET<span class="required-hint">*</span></div>
				
			<a-input v-model="r_api_secret" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div v-show="r_report_method == '2'" class="form-cell-box">
			<div class="class-title">回传比例<span class="required-hint">*</span></div>
				
			<a-input-number style="width:100px;" id="inputNumber" v-model="r_report_per" :min="0" :max="1000"  />
		</div>
		
		
		<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 130px;">
			<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="addCloseDrawer">返回</a-button>
		</div>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
import {  putDataMenu, landPagePlatform,landPageJumpType, landPageChannelGzh, 
getPutDomain,landPageSixMedia, landSixTemplate, landOppoList, landVivoList, 
landGzhXcx, landAddUploadImage, landAddButton, landAddGzhCode, landEditGet, landEditButton } from '@/request/api'
import Editors from '@/components/Editors.vue'
export default {
	name: 'landAdd360_',
	components: {
		Editors
	},
	data() {
		return {
			// 筛选条件部分
			filterData: {
				op_id:{ // 投手
					list: [{}],
				},
				channel_id:{ // 书城渠道
					list: [{}],
				},
				gzh_id:{ // 公众号
					list: [{}],
				},
				
			}, // 筛选条件数组
			PlatformData: {}, // 落地页推广平台数据
			JumpTypeData: {}, // 落地页跳转方式数据
			
			channel_idList: [], // 渠道数据
			
			widths: 630, // 内容的宽度
			// 新增侧边栏
			add_visible: false, 
			aaa:"",
			add_type: "0", // 新增类型。0为新增头条/广点通/OPPO/VIVO落地页。1为新增百度跳转页。2为新增360落地页
			add_drawer_title: "新增360落地页",
			add_form_hint: "", // 新增侧边栏的提示
			add_button_loading: false,
			gzhSelectList: {},
			mediaSelectList: {},
			sixMubanList: {},
			domainList: {},
			
			
			// 360
			gzh_360_code_url: "", // 360落地页公众号二维码
			
			headers_token: "", // 图片上传用的token
			loading: false,
			imageUrl: '',
			
			r_title: "", // 落地页名称
			r_put_platform: "360", // 投放平台。根据不同的投放平台控制页面显示不同的填写内容
			r_channel_id: undefined, // 渠道id
			r_gzh_id:undefined, // 公众号id
			
			r_background_color: "#FFFFFF", // 背景色
			
			r_put_url: undefined, // 投放域名id
			
			r_company_name: "", // 审核公司。投放平台不为百度必填项company_name审核公司
			r_jump_type: "scan", // 跳转方式。跳转地址
			
			r_top_image: "", // 头部图片
			r_put_content: "", // 富文本-投放内容
			r_open_put: false, // 投放开关。是否打开投放  0=否，1=是
			
			r_report_per: 100, // 回传比例
			
			// 360
			r_foreign_id: "", // 360账号ID or API_JZQS
			r_foreign_code: "", // 360转化代码ID
			r_logo: "", // 网址名称
			r_phone: "", // 联系电话
			r_address: "", // 公司地址
			r_report_method: "1", // 回传方式
			r_api_key: "", // API_KEY
			r_api_secret: "", // API_SECRET
			r_media_id: undefined, // 媒体版位
			r_template_id: undefined, // 页面样式模板
			
			search_button_loading: false,
			
			// 编辑
			r_link_id: "", // 编辑传过来的参数
			put_disabled: false, // 投放平台是否禁用
			page_title: "新增", // 页面标题
		}
	},
	mounted() {
		let that = this
		
		that.search_button_loading = true
		
		// 图片上传用的token
		this.headers_token = 'Bearer ' + localStorage.getItem("access_token")
		
		putDataMenu().then(res=>{
			console.log("筛选条件",res.data.data)
			// if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				that.filterData = res.data.data.filter
				let fff = res.data.data.filter.channel_id.list
				
				// 去重，避免有重复的key，然后报错。有重复内容用于select组件会报错。
				let obj = {};
				fff = fff.reduce(function(item, next) {
				   obj[next.key] ? '' : obj[next.key] = true && item.push(next);
				   return item;
				}, []);
				console.log(fff);
				that.channel_idList =  fff
				
			// }
			// else {
			// 	if(res.data.code === 401){ // 未登录
			// 		localStorage.removeItem("access_token");
			// 		that.$router.replace({name: 'login',params: {type:'not_log'}})
			// 	}
			// 	else {
			// 		that.$message.error(`其他错误：${res.data.msg}`);
			// 	}
			// }
			
		})
		
		// 360媒体版位下拉列表
		landPageSixMedia().then(res=>{
			console.log("360媒体版位下拉列表",res.data);
			that.mediaSelectList = res.data.data.list
		})
		
		// 获取转换域名
		getPutDomain().then(res=>{
			console.log("获取转换域名",res.data);
			that.domainList = res.data.data.data
		})
		
		landPagePlatform().then(res=>{
			console.log("落地页推广平台",res.data.data);
			that.PlatformData = res.data.data.list
		}) 
		
		landPageJumpType().then(res=>{
			console.log("落地页跳转方式",res.data.data);
			that.JumpTypeData = res.data.data.list
		})
		
		landSixTemplate({media_id:9}).then(res=>{
			console.log("360媒体版位对应落地页模板",res);
			that.sixMubanList = res.data.data.list
		})
		
		if(that.$route.query){
			// 接收从小程序跳转码页面传过来的参数、小程序跳转码每日使用量页
			if(that.$route.query.link_id){
				that.r_link_id = that.$route.query.link_id
				that.put_disabled = true // 平台选择禁用
				that.page_title = "编辑"
				// 获取编辑的内容
				landEditGet({
					id: that.r_link_id
				}).then(res=>{
					console.log("获取编辑的内容",res.data.data.info);
					
					let editObject = res.data.data.info
					that.r_title = editObject.title // 名称
					that.r_channel_id = editObject.channel_id // 渠道id
					that.addChangeA(editObject.channel_id) // 获取公众号选择器内容
					that.r_gzh_id = editObject.gzh_id.toString() // 公众号id
					that.addChangeB(that.r_gzh_id) // 获取公众号相关内容
					that.r_put_platform = editObject.put_platform // 投放平台
					
					that.r_jump_type = editObject.jump_type // 跳转方式
					that.r_report_method = editObject.report_method.toString() // 回传方式
					that.r_media_id = editObject.media_id.toString()  // 媒体版位
					that.addChangeD(that.r_media_id)
					that.r_template_id = editObject.template_id.toString()  // 页面样式模板
					that.r_company_name = editObject.company_name  // 审核公司
					
					that.r_background_color = editObject.background_color
					
					that.r_put_url = editObject.put_url.toString() // 域名地址
					
					let jsonObj = JSON.parse(editObject.memo)
					// console.log("jsonObj",jsonObj);
					that.r_logo = jsonObj.logo // 网址名称
					that.r_phone = jsonObj.phone // 联系电话
					that.r_address = jsonObj.address // 公司地址
					
					
					// 回传方式
					if(that.r_report_method == '1'){ // 页面底部JS回传
						that.r_foreign_id = editObject.foreign_id
						that.r_foreign_code = editObject.foreign_code
					}
					else if(that.r_report_method == '2'){ // 关注API回传
						that.r_foreign_id = editObject.foreign_id
						that.r_api_key = editObject.api_key
						that.r_api_secret = editObject.api_secret
						that.r_report_per = editObject.report_per
					}
					
					// 选填内容
					if(editObject.top_image_path){ // 头部图片
						that.r_top_image = editObject.top_image_path
						that.imageUrl = editObject.top_image || ""
					}
					if(editObject.put_content){ // 投放内容
						that.r_put_content = editObject.put_content
					}
					console.log("that.r_put_content",that.r_put_content);
					// 投放开关 or 百度里的 是否回传加粉
					if(editObject.open_put == 1){
						that.r_open_put = true // 打开
					}
					else {
						that.r_open_put = false // 关闭
					}
					
					
					setTimeout(()=>{
						that.search_button_loading = false
					},300)
				})
			}
			else {
				setTimeout(()=>{
					that.search_button_loading = false
				},500)
			}
			
		}
		else {
			setTimeout(()=>{
				that.search_button_loading = false
			},500)
		}
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 新增部分开始------
		
		
		// 新增侧边栏-选择渠道
		addChangeA(e){
			let that = this
			console.log(e);
			that.r_gzh_id = undefined
			that.r_channel_id = e
			// 渠道公众号
			landPageChannelGzh({channel_id: e}).then(res=>{
				console.log("渠道公众号",res.data.data);
				that.gzhSelectList = res.data.data.list
			})
		},
		// 选择公众号
		addChangeB(e){
			let that = this
			console.log(e);
			
			this.r_gzh_id = e
			
			// 获取公众号二维码
			landAddGzhCode({
				gzh_id: e
			}).then(res=>{
				console.log("获取公众号二维码",res);
				that.gzh_360_code_url = res.data.data.qr_code
			})
		},
		
		// 新增侧边栏-跳转方式
		addChangeC(e){
			this.r_jump_type = e
		},
		
		// 360付费方式
		addChangeG360(e){
			this.r_foreign_id = ""
			this.r_report_method = e
		},
		
		
		// 新增侧边栏-媒体版位
		addChangeD(e){
			let that = this
			console.log(e);
			this.r_template_id = undefined
			this.r_media_id = e
			// landSixTemplate({media_id:e}).then(res=>{
			// 	console.log("360媒体版位对应落地页模板",res);
			// 	that.sixMubanList = res.data.data.list
			// })
		},
		// 新增侧边栏-页面样式模板
		addChangeE(e){
			this.r_template_id = e
		},
		// 新增侧边栏-投放域名地址
		addChangeF(e){
			this.r_put_url = e
		},
		
		addChangeTC(e){ // 投放开关
			this.r_open_put = e
		},
		
		// 选择背景色
		changeColor(e){
			// console.log(e);
			this.r_background_color = e.target.value
		},
		
		// 顶部图片上传 限制用户上传的图片格式和大小。
		beforeUpload(file){
			console.log("beforeUpload",file);
				
			// if(this.add_wx_kf_account_id){
				  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				  if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				  }
				  const isLt2M = file.size / 1024 / 1024 < 2;
				  if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				  }
				  return isJpgOrPng && isLt2M;
			// }
			// else {
			// 	this.$message.warning('请先选择企业');
			// }
		},
		uploadChange(info){
			// console.log("图片请求",info);
			let that = this
			if (info.file.status === 'uploading') {
					this.loading = true;
					return;
			}
			if (info.file.status === 'done') {
				console.log("图片请求done",info);
				if(info.file.response){ // 图片上传成功，有内容返回
					// this.add_wx_kf_media_id = info.file.response.data.media_id
					that.r_top_image = info.file.response.data.path
					that.imageUrl = info.file.response.data.url
					that.loading = false
					// getBase64(info.file.originFileObj, imageUrl => {
					//   this.imageUrl = imageUrl;
					//   this.loading = false;
					// });
				}
				else {
					this.imageUrl = ""
					this.loading = false;
					this.$message.error(`错误：图片上传失败`);
				}
			}
			
			if (info.file.status === 'error') { // 上传失败
				
				this.imageUrl = ""
				this.loading = false;
				this.$message.error(`错误：图片上传失败`);
			
			}
		},
		// 删除选择的图片
		delTopImg(){
			this.imageUrl = ""
			this.r_top_image = ""
		},
		changeEditorT(e){ // 投放内容
			console.log(e);
			this.r_put_content = e
		},
		
		
		
		// 新增侧边栏确认按钮
		addRequest(){
			let that = this
			console.log("that.r_template_id",that.r_template_id);
			
			// console.log("that.r_top_image",that.r_top_image);
			
			
			// 检查必填项
			if(!that.r_title){
				that.$message.warning('请填写名称');
			}
			else if(!that.r_channel_id){
				that.$message.warning('请选择渠道');
			}
			else if(!that.r_gzh_id){
				that.$message.warning('请选择公众号');
			}
			else if(!that.r_media_id){
				that.$message.warning('请选择媒体版位');
			}
			else if(!that.r_template_id){
				that.$message.warning('请选择页面样式模板');
			}
			else if(!that.r_put_url){
				that.$message.warning('请选择域名地址');
			}
			else if(!that.r_company_name){
				that.$message.warning('请输入审核公司');
			}
			else if(!that.r_logo){
				that.$message.warning('请输入网址名称');
			}
			else if(!that.r_phone){
				that.$message.warning('请输入联系电话');
			}
			else if(!that.r_address){
				that.$message.warning('请输入公司地址');
			}
			else if(!that.r_jump_type){
				that.$message.warning('请选择跳转方式');
			}
			else if(!that.r_report_method){
				that.$message.warning('请选择回传方式');
			}
			else if(!that.r_foreign_id && that.r_report_method == '1'){
				that.$message.warning('请输入360账号ID');
			}
			else if(!that.r_foreign_code && that.r_report_method == '1'){
				that.$message.warning('请输入360转化代码ID');
			}
			else if(!that.r_foreign_id && that.r_report_method == '2'){
				that.$message.warning('请输入API_JZQS');
			}
			else if(!that.r_api_key && that.r_report_method == '2'){
				that.$message.warning('请输入API_KEY');
			}
			else if(!that.r_api_secret && that.r_report_method == '2'){
				that.$message.warning('请输入API_SECRET');
			}
			
			else {
				that.search_button_loading = true
				console.log("else");
				// 必填内容
				let r_data = {
					
					put_platform: that.r_put_platform, // 投放平台
					title: that.r_title, // 落地页名称
					channel_id: that.r_channel_id, // 渠道id
					gzh_id: that.r_gzh_id, // 公众号id
					
					jump_type: that.r_jump_type, // 跳转方式
					report_method: that.r_report_method, // 回传方式
					media_id: that.r_media_id, // 媒体版位
					template_id: that.r_template_id, // 页面样式模板
					company_name: that.r_company_name, // 审核公司
					
					background_color: that.r_background_color, // 背景色
					
					put_url: that.r_put_url, // 投放域名地址
					logo: that.r_logo, // 网址名称
					phone: that.r_phone, // 联系电话
					address: that.r_address, // 公司地址
					
					// 360落地页用不到这个，传默认值就行
					report_only_cur_day: 1,
					report_only_once: 1,
					jump_content_type: 1,
				}
				// 回传方式
				if(that.r_report_method == '1'){ // 页面底部JS回传
					r_data.foreign_id = that.r_foreign_id
					r_data.foreign_code = that.r_foreign_code
				}
				else if(that.r_report_method == '2'){ // 关注API回传
					r_data.foreign_id = that.r_foreign_id
					r_data.api_key = that.r_api_key
					r_data.api_secret = that.r_api_secret
					r_data.report_per = that.r_report_per
				}
				
				// 选填内容
				if(that.r_top_image){ // 头部图片
					r_data.top_image = that.r_top_image
				}
				if(that.r_put_content){ // 投放内容
					r_data.put_content = that.r_put_content
				}
				
				// 投放开关 or 百度里的 是否回传加粉
				if(that.r_open_put){
					r_data.open_put = 1 // 打开
				}
				else {
					r_data.open_put = 0 // 关闭
				}
				if(that.page_title == "新增"){
					console.log("r_data",r_data);
					landAddButton(r_data).then(res=>{
						console.log("提交按钮",res);
						that.search_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('新增成功');
							setTimeout(()=>{
								that.$router.replace({name: 'landPage_',params: {}})
							},1000)
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
				}
				else if(that.page_title == "编辑"){
					r_data.id = that.r_link_id
					landEditButton(r_data).then(res=>{
						console.log("编辑提交按钮",res);
						that.search_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('编辑成功');
							setTimeout(()=>{
								that.$router.replace({name: 'landPage_',params: {}})
							},1000)
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
				}
			}
		},
		// 新增侧边栏取消按钮
		addCloseDrawer(){
			this.$router.replace({name: 'landPage_',params: {}})
		},
	}
}		
</script>

<style scoped>
.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.class-title {
	position: relative;
	font-size: 14px;
	margin-right: 25px;
	width: 190px;
	color: #333;
	text-align: right;
}

/* 必填提示 */
.required-hint {
	color: red;
	position: absolute;
	right: -8px;
}
</style>